module.exports = {
  "/:articleId": {},
  "/:articleId/revisions": {
    "success": {
      "revision modal rendered": [
        "PARENT_APP_CHROME_RENDERED",
        "REVISIONS_MODAL_RENDERED"
      ]
    },
    "error": [
      "ASYNC_COMPONENT_FAILED_TO_LOAD",
      "ERROR_PAGE_RENDERED"
    ]
  },
  "/:articleId/content": {
    "success": {
      "inpage editor ready": [
        "PARENT_APP_CHROME_RENDERED",
        "INPAGE_EDITOR_READY"
      ]
    },
    "error": [
      "ASYNC_COMPONENT_FAILED_TO_LOAD",
      "ERROR_PAGE_RENDERED"
    ]
  },
  "/:articleId/preview": {
    "success": {
      "preview modal rendered": [
        "PARENT_APP_CHROME_RENDERED",
        "PREVIEW_MODAL_RENDERED",
        "INPAGE_EDITOR_READY"
      ]
    },
    "error": [
      "ASYNC_COMPONENT_FAILED_TO_LOAD",
      "ERROR_PAGE_RENDERED"
    ]
  }
};